import {
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
  onAuthStateChanged,
} from 'firebase/auth'
import { getFirebaseAuth } from '../firebaseClient'
import type { PartnerClaims } from '../types/auth'

export async function signIn(email: string, password: string) {
  const auth = getFirebaseAuth()
  const credential = await signInWithEmailAndPassword(auth, email, password)
  return credential.user
}

export async function signOutUser(): Promise<void> {
  const auth = getFirebaseAuth()
  await firebaseSignOut(auth)
}

export function onAuthChanged(callback: (user: any) => void): () => void {
  const auth = getFirebaseAuth()
  return onAuthStateChanged(auth, callback)
}

export async function getPartnerClaims(user: any): Promise<PartnerClaims> {
  const tokenResult = await user.getIdTokenResult(true)
  return {
    role: tokenResult.claims.role as string | undefined,
    distributorId: tokenResult.claims.distributorId as string | undefined,
  }
}

export function isPartnerRole(claims: PartnerClaims | null): boolean {
  return claims?.role === 'partner' && typeof claims.distributorId === 'string' && claims.distributorId.length > 0
}
